module.exports = __webpack_public_path__ + "static/media/progress_beschreibung.0ef5706a.svg";